import React from "react";
import { Modal } from "antd";

interface PhotoPreviewModalProps {
  visible: boolean;
  title: string;
  imageUrl: string;
  onClose: () => void;
}

const PhotoPreviewModal: React.FC<PhotoPreviewModalProps> = ({
  visible,
  title,
  imageUrl,
  onClose
}) => {
  return (
    <Modal
      open={visible}
      title={title}
      footer={null}
      onCancel={onClose}
    >
      <img alt={title} style={{ width: "100%" }} src={imageUrl} />
    </Modal>
  );
};

export default PhotoPreviewModal;